import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lobby-status-text"
}
const _hoisted_2 = {
  key: 1,
  class: "lobby-status-text"
}
const _hoisted_3 = {
  key: 2,
  class: "lobby-status-text"
}

import { watch, ref, computed } from 'vue'
import { LobbyTimerUi, LobbyTimersUi } from '@/model/LobbyTimers'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'CLobbyStatus',
  props: {
    timers: {},
    isBanner: { type: Boolean, default: false }
  },
  emits: ['lobby-timer-complete'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const { t } = useI18n()
const countdownTxt = ref('')

watch(
  () => props.timers,
  (newVal: LobbyTimersUi, oldVal: LobbyTimersUi) => {
    const time = props.timers.start

    countdownTxt.value = `${getDays(time)} ${getHours(time)} ${getMinutes(time)} ${getSeconds(time)}`

    if (
      oldVal &&
      ((newVal.start.totalSecs === 0 && newVal.start.totalSecs !== oldVal.start.totalSecs) ||
        (newVal.end.totalSecs === 0 && newVal.end.totalSecs !== oldVal.end.totalSecs))
    ) {
      setTimeout(() => {
        emit('lobby-timer-complete')
      }, 1000)
    }
  },
  { immediate: true, deep: true }
)

const isOpen = computed(() => {
  return props.timers.start.totalSecs === 0 && props.timers.end.totalSecs > 0
})

const willOpen = computed(() => {
  return props.timers.start.totalSecs > 0
})

const isClosed = computed(() => {
  return props.timers.start.totalSecs <= 0 && props.timers.end.totalSecs <= 0
})

/**
 * Days string
 * plus adding grammatic syntax sugar on top (comma or coordinating conjunction)
 */
function getDays(time: LobbyTimerUi): string {
  let daysStr = t('zoneSelection.lobbyStatusBanner.countdown_days', time.days)
  if (time.days > 0) {
    if (time.hours > 0 && time.minutes > 0) {
      daysStr += ', '
    } else if (time.hours > 0 || time.minutes > 0) {
      daysStr += ` ${t('zoneSelection.lobbyStatusBanner.countdown_and')} `
    }
  }
  return time.days > 0 ? daysStr : ''
}

/**
 * Hours string
 * plus adding grammatic syntax sugar on top (comma or coordinating conjunction)
 */
function getHours(time: LobbyTimerUi): string {
  let hoursStr = t('zoneSelection.lobbyStatusBanner.countdown_hours', time.hours)
  if (time.hours > 0) {
    if (time.minutes > 0) {
      hoursStr += ` ${t('zoneSelection.lobbyStatusBanner.countdown_and')} `
    }
  } else {
    hoursStr += ', '
  }
  return time.hours > 0 ? hoursStr : ''
}

/**
 * Minutes string
 * plus adding grammatic syntax sugar on top (comma or coordinating conjunction)
 */
function getMinutes(time: LobbyTimerUi): string {
  let minuteStr = t('zoneSelection.lobbyStatusBanner.countdown_minutes', time.minutes)
  if (time.days <= 0 && time.hours <= 0 && time.minutes < 5 && time.seconds > 0) {
    minuteStr += ` ${t('zoneSelection.lobbyStatusBanner.countdown_and')} `
  }
  return time.minutes > 0 ? minuteStr : ''
}

/**
 * Seconds string
 * plus adding grammatic syntax sugar on top (comma or coordinating conjunction)
 */
function getSeconds(time: LobbyTimerUi): string {
  let seconds = ''
  if (time.days <= 0 && time.hours <= 0 && time.minutes < 5 && time.seconds > 0) {
    seconds = t('zoneSelection.lobbyStatusBanner.countdown_seconds', time.seconds)
  }
  return seconds
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ isBanner: _ctx.isBanner }, isOpen.value ? 'open' : 'closed']),
    "data-qe-id": "lobby-status"
  }, [
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "icon" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t('zoneSelection.lobbyStatusBanner.isOpen')), 1)
        ]))
      : _createCommentVNode("", true),
    (willOpen.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "icon" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t('zoneSelection.lobbyStatusBanner.willOpen', { openingTime: countdownTxt.value })), 1)
        ]))
      : _createCommentVNode("", true),
    (isClosed.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "icon" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t('zoneSelection.lobbyStatusBanner.isClosed')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})